import {
  WebSocketSessionzi1ianvyj32u as WebSocketSession,
  closeo8vfd19wahfw as close,
  closeExceptionally3ggedzec0vibq as closeExceptionally,
  send3kjrrxgwu0vpw as send,
} from './WebSocketSession.mjs';
import {
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  Companion_getInstance1u99479g32m9i as Companion_getInstance,
  from3gpkuvfyl3bft as from,
  ChannelOverflow_SUSPEND_getInstance3qrqbtoutxinz as ChannelOverflow_SUSPEND_getInstance,
  ChannelConfigftdbykui5s0q as ChannelConfig,
} from './WebSocketChannelsConfig.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
} from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  toString1pkumu07cwy4m as toString,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Dispatchers_getInstance2p2r3ndn98nn as Dispatchers_getInstance } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/Dispatchers.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { CoroutineStart_UNDISPATCHED_getInstance3vhik5zct4e74 as CoroutineStart_UNDISPATCHED_getInstance } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineStart.mjs';
import { get_isTraceEnabled82xibuu04nxp as get_isTraceEnabled } from '../../../../ktor-ktor-utils/io/ktor/util/logging/Logger.web.mjs';
import {
  Binary3tlzyfojm51s4 as Binary,
  Text3e6ukp9joohql as Text,
  Close3tx65evcwi73t as Close,
  Pong3m3cas9hmc9ec as Pong,
  Companion_getInstance13o6h9kfs12i5 as Companion_getInstance_0,
  Ping3nta6l7sdq1r9 as Ping,
} from './Frame.web.mjs';
import {
  readReason2qq1b0s02pdpy as readReason,
  NonDisposableHandle_instance3amt6bvd9jgby as NonDisposableHandle_instance,
} from './FrameCommon.mjs';
import { toString30pk9tzaqopn as toString_0 } from '../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  CloseReason10cphaqpp3ct7 as CloseReason,
  Codes_NORMAL_getInstance1akc4vzdzyb59 as Codes_NORMAL_getInstance,
  Codes_CLOSED_ABNORMALLY_getInstance2rjj5xk3ewrku as Codes_CLOSED_ABNORMALLY_getInstance,
  Codes_TOO_BIG_getInstance3nttbnss50yoi as Codes_TOO_BIG_getInstance,
} from './CloseReason.mjs';
import {
  pingerd16zvjbf6m9o as pinger,
  ponger270tezdl2mu68 as ponger,
} from './PingPong.mjs';
import {
  ChannelResult2y4k69ac6y3du as ChannelResult,
  _ChannelResult___get_isSuccess__impl__odq1z912b5ogo8613be as _ChannelResult___get_isSuccess__impl__odq1z9,
  ClosedSendChannelException29m33prpq9jaw as ClosedSendChannelException,
  ClosedReceiveChannelException3ofg6gf5f5b38 as ClosedReceiveChannelException,
  Factory_getInstance3boxsed5qz5iy as Factory_getInstance,
} from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/channels/Channel.mjs';
import {
  get_size2imoy2jq11jxl as get_size,
  BytePacketBuilder2biodf4wxvlba as BytePacketBuilder,
  writeFully359t6q8kam2g5 as writeFully,
  buildjygoh729rhy8 as build,
} from '../../../../ktor-ktor-io/io/ktor/utils/io/core/BytePacketBuilder.mjs';
import { FrameTooBigException1rgdafsgu31sm as FrameTooBigException } from './FrameTooBigException.mjs';
import { fromInt2ii0rejb1w62w as fromInt } from '../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { readByteArray1ri21h2rciakw as readByteArray } from '../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/Sources.mjs';
import { cancelConsumed2i0oizqhmljf6 as cancelConsumed } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/channels/Channels.common.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import { ChannelIOException2i3t76lsrbgox as ChannelIOException } from '../../../../ktor-ktor-utils/io/ktor/util/cio/Channels.mjs';
import { IOException1wyutdmfe71nu as IOException } from '../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/-PlatformJs.mjs';
import {
  atomic$ref$130aurmcwdfdf1 as atomic$ref$1,
  atomic$boolean$1iggki4z65a2h as atomic$boolean$1,
} from '../../../../kotlinx-atomicfu/kotlinx/atomicfu/AtomicFU.mjs';
import { CompletableDeferred2lnqvsbvx74d3 as CompletableDeferred } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/CompletableDeferred.mjs';
import {
  Job13y4jkazwjho0 as Job,
  Key_instance2rlngjw9v1qsd as Key_instance,
} from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/Job.mjs';
import { CoroutineName2g5zosw74tf0f as CoroutineName } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineName.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { joinToString1cxrrlmo0chqs as joinToString } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { KtorSimpleLogger1xdphsp5l4e48 as KtorSimpleLogger } from '../../../../ktor-ktor-utils/io/ktor/util/logging/KtorSimpleLogger.web.mjs';
import { get_OUTGOING_CHANNEL_CAPACITY2ancx42jsldm9 as get_OUTGOING_CHANNEL_CAPACITY } from './Utils.web.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_LOGGER() {
  _init_properties_DefaultWebSocketSession_kt__469s0y();
  return LOGGER;
}
var LOGGER;
function get_IncomingProcessorCoroutineName() {
  _init_properties_DefaultWebSocketSession_kt__469s0y();
  return IncomingProcessorCoroutineName;
}
var IncomingProcessorCoroutineName;
function get_OutgoingProcessorCoroutineName() {
  _init_properties_DefaultWebSocketSession_kt__469s0y();
  return OutgoingProcessorCoroutineName;
}
var OutgoingProcessorCoroutineName;
function get_NORMAL_CLOSE() {
  _init_properties_DefaultWebSocketSession_kt__469s0y();
  return NORMAL_CLOSE;
}
var NORMAL_CLOSE;
var OUTGOING_CHANNEL_CONFIG;
var DefaultWebSocketSessionClass;
function DefaultWebSocketSession() {
  if (DefaultWebSocketSessionClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'DefaultWebSocketSession', VOID, VOID, [WebSocketSession()], [1, 0]);
    DefaultWebSocketSessionClass = $;
  }
  return DefaultWebSocketSessionClass;
}
function DefaultWebSocketSession_0(session, pingIntervalMillis, timeoutMillis, channelsConfig) {
  pingIntervalMillis = pingIntervalMillis === VOID ? 0n : pingIntervalMillis;
  timeoutMillis = timeoutMillis === VOID ? 15000n : timeoutMillis;
  channelsConfig = channelsConfig === VOID ? Companion_getInstance().a5a_1 : channelsConfig;
  _init_properties_DefaultWebSocketSession_kt__469s0y();
  // Inline function 'kotlin.require' call
  if (!!isInterface(session, DefaultWebSocketSession())) {
    var message = 'Cannot wrap other DefaultWebSocketSession';
    throw IllegalArgumentException().n2(toString(message));
  }
  return new (DefaultWebSocketSessionImpl())(session, pingIntervalMillis, timeoutMillis, channelsConfig.b5a_1, channelsConfig.c5a_1);
}
function runIncomingProcessor($this, ponger) {
  var tmp = get_IncomingProcessorCoroutineName().hm(Dispatchers_getInstance().d13_1);
  return launch($this, tmp, VOID, DefaultWebSocketSessionImpl$runIncomingProcessor$slambda_0($this, ponger));
}
function runOutgoingProcessor($this) {
  var tmp = get_OutgoingProcessorCoroutineName().hm(Dispatchers_getInstance().d13_1);
  var tmp_0 = CoroutineStart_UNDISPATCHED_getInstance();
  return launch($this, tmp, tmp_0, DefaultWebSocketSessionImpl$runOutgoingProcessor$slambda_0($this));
}
function *outgoingProcessorLoop($this, $completion) {
  var _iterator__ex2g4s = $this.j5a_1.p1();
  $l$loop: while (yield* _iterator__ex2g4s.j1a($completion)) {
    var frame = _iterator__ex2g4s.r1();
    // Inline function 'io.ktor.util.logging.trace' call
    var this_0 = get_LOGGER();
    if (get_isTraceEnabled(this_0)) {
      var tmp$ret$1 = 'Sending ' + frame.toString() + ' from session ' + toString($this);
      this_0.k4s(tmp$ret$1);
    }
    var tmp;
    if (frame instanceof Close()) {
      yield* sendCloseSequence($this, readReason(frame), VOID, $completion);
      break $l$loop;
    } else {
      var tmp_0;
      if (frame instanceof Text()) {
        tmp_0 = true;
      } else {
        tmp_0 = frame instanceof Binary();
      }
      if (tmp_0) {
        tmp = processOutgoingExtensions($this, frame);
      } else {
        tmp = frame;
      }
    }
    var processedFrame = tmp;
    yield* $this.d5a_1.y59().x1a(processedFrame, $completion);
  }
  return Unit_instance;
}
function *sendCloseSequence($this, reason, exception, $completion) {
  exception = exception === VOID ? null : exception;
  if (!tryClose($this))
    return Unit_instance;
  // Inline function 'io.ktor.util.logging.trace' call
  var this_0 = get_LOGGER();
  if (get_isTraceEnabled(this_0)) {
    var tmp$ret$1 = 'Sending Close Sequence for session ' + toString($this) + ' with reason ' + toString_0(reason) + ' and exception ' + toString_0(exception);
    this_0.k4s(tmp$ret$1);
  }
  $this.g5a_1.p12();
  var reasonToSend = reason == null ? CloseReason().r59(Codes_NORMAL_getInstance(), '') : reason;
  try {
    runOrCancelPinger($this);
    if (!(reasonToSend.o59_1 === Codes_CLOSED_ABNORMALLY_getInstance().k59_1)) {
      yield* $this.d5a_1.y59().x1a(Close().x5a(reasonToSend), $completion);
    }
  }finally {
    $this.f5a_1.n12(reasonToSend);
    if (!(exception == null)) {
      $this.j5a_1.i1b(exception);
      $this.i5a_1.i1b(exception);
    }
  }
  return Unit_instance;
}
function tryClose($this) {
  return $this.k5a_1.atomicfu$compareAndSet(false, true);
}
function runOrCancelPinger($this) {
  var interval = $this.n5a_1;
  var tmp;
  if ($this.k5a_1.kotlinx$atomicfu$value) {
    tmp = null;
  } else if (interval > 0n) {
    var tmp_0 = $this.d5a_1.y59();
    var tmp_1 = $this.o5a_1;
    tmp = pinger($this, tmp_0, interval, tmp_1, DefaultWebSocketSessionImpl$runOrCancelPinger$slambda_0($this));
  } else {
    tmp = null;
  }
  var newPinger = tmp;
  var tmp0_safe_receiver = $this.e5a_1.atomicfu$getAndSet(newPinger);
  if (tmp0_safe_receiver == null)
    null;
  else
    tmp0_safe_receiver.k1b();
  var tmp2_safe_receiver = newPinger == null ? null : new (ChannelResult())(newPinger.y1a(Companion_getInstance_1().y5a_1));
  if (tmp2_safe_receiver == null)
    null;
  else
    _ChannelResult___get_isSuccess__impl__odq1z9(tmp2_safe_receiver.w1a_1);
  if ($this.k5a_1.kotlinx$atomicfu$value && !(newPinger == null)) {
    runOrCancelPinger($this);
  }
}
function *checkMaxFrameSize($this, packet, frame, $completion) {
  var tmp = frame.b5b_1.length;
  var tmp1_elvis_lhs = packet == null ? null : get_size(packet);
  var size = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
  if (fromInt(size) > $this.w59()) {
    if (packet == null)
      null;
    else {
      packet.l6();
    }
    yield* close($this, CloseReason().r59(Codes_TOO_BIG_getInstance(), 'Frame is too big: ' + size + '. Max size is ' + $this.w59().toString()), $completion);
    throw FrameTooBigException().j5b(fromInt(size));
  }
  return Unit_instance;
}
function processIncomingExtensions($this, frame) {
  // Inline function 'kotlin.collections.fold' call
  var accumulator = frame;
  var _iterator__ex2g4s = $this.k5b().p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    var current = accumulator;
    accumulator = element.l5b(current);
  }
  return accumulator;
}
function processOutgoingExtensions($this, frame) {
  // Inline function 'kotlin.collections.fold' call
  var accumulator = frame;
  var _iterator__ex2g4s = $this.k5b().p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    var current = accumulator;
    accumulator = element.m5b(current);
  }
  return accumulator;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.y5a_1 = Pong().u5b(new Int8Array(0), NonDisposableHandle_instance);
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_1() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var DefaultWebSocketSessionImpl$start$slambdaClass;
function DefaultWebSocketSessionImpl$start$slambda() {
  if (DefaultWebSocketSessionImpl$start$slambdaClass === VOID) {
    class $ {
      constructor($incomingJob, $outgoingJob, this$0) {
        this.v5b_1 = $incomingJob;
        this.w5b_1 = $outgoingJob;
        this.x5b_1 = this$0;
      }
      *w1f($this$launch, $completion) {
        yield* this.v5b_1.ex($completion);
        yield* this.w5b_1.ex($completion);
        this.x5b_1.g5a_1.ix();
        return Unit_instance;
      }
      ld(p1, $completion) {
        return this.w1f((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    DefaultWebSocketSessionImpl$start$slambdaClass = $;
  }
  return DefaultWebSocketSessionImpl$start$slambdaClass;
}
function DefaultWebSocketSessionImpl$start$slambda_0($incomingJob, $outgoingJob, this$0) {
  var i = new (DefaultWebSocketSessionImpl$start$slambda())($incomingJob, $outgoingJob, this$0);
  var l = ($this$launch, $completion) => i.w1f($this$launch, $completion);
  l.$arity = 1;
  return l;
}
var DefaultWebSocketSessionImpl$runIncomingProcessor$slambdaClass;
function DefaultWebSocketSessionImpl$runIncomingProcessor$slambda() {
  if (DefaultWebSocketSessionImpl$runIncomingProcessor$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $ponger) {
        this.y5b_1 = this$0;
        this.z5b_1 = $ponger;
      }
      *w1f($this$launch, $completion) {
        var firstFrame = null;
        var frameBody = null;
        var closeFramePresented = false;
        try {
          // Inline function 'kotlinx.coroutines.channels.consumeEach' call
          var tmp0 = this.y5b_1.d5a_1.x59();
          $l$block_1: {
            // Inline function 'kotlinx.coroutines.channels.consume' call
            var cause = null;
            try {
              var _iterator__ex2g4s = tmp0.p1();
              while (yield* _iterator__ex2g4s.j1a($completion)) {
                var e = _iterator__ex2g4s.r1();
                $l$block_0: {
                  // Inline function 'io.ktor.util.logging.trace' call
                  var this_0 = get_LOGGER();
                  if (get_isTraceEnabled(this_0)) {
                    var tmp$ret$5 = 'WebSocketSession(' + toString($this$launch) + ') receiving frame ' + e.toString();
                    this_0.k4s(tmp$ret$5);
                  }
                  if (e instanceof Close()) {
                    if (!this.y5b_1.y59().q1a()) {
                      var tmp = this.y5b_1.y59();
                      var tmp1_elvis_lhs = readReason(e);
                      yield* tmp.x1a(Close().x5a(tmp1_elvis_lhs == null ? get_NORMAL_CLOSE() : tmp1_elvis_lhs), $completion);
                    }
                    closeFramePresented = true;
                    return Unit_instance;
                  } else {
                    if (e instanceof Pong()) {
                      var tmp2_safe_receiver = this.y5b_1.e5a_1.kotlinx$atomicfu$value;
                      if (tmp2_safe_receiver == null)
                        null;
                      else
                        yield* tmp2_safe_receiver.x1a(e, $completion);
                    } else {
                      if (e instanceof Ping())
                        yield* this.z5b_1.x1a(e, $completion);
                      else {
                        yield* /*#__NOINLINE__*/checkMaxFrameSize(this.y5b_1, frameBody, e, $completion);
                        if (!e.z5a_1) {
                          if (firstFrame == null) {
                            firstFrame = e;
                          }
                          if (frameBody == null) {
                            frameBody = BytePacketBuilder();
                          }
                          writeFully(frameBody, e.b5b_1);
                          break $l$block_0;
                        }
                        if (firstFrame == null) {
                          yield* this.y5b_1.i5a_1.x1a(processIncomingExtensions(this.y5b_1, e), $completion);
                          break $l$block_0;
                        }
                        writeFully(ensureNotNull(frameBody), e.b5b_1);
                        var defragmented = Companion_getInstance_0().b5c(true, firstFrame.a5b_1, readByteArray(build(frameBody)), firstFrame.d5b_1, firstFrame.e5b_1, firstFrame.f5b_1);
                        firstFrame = null;
                        yield* this.y5b_1.i5a_1.x1a(processIncomingExtensions(this.y5b_1, defragmented), $completion);
                      }
                    }
                  }
                }
              }
              break $l$block_1;
            } catch ($p) {
              if ($p instanceof Error) {
                var e_0 = $p;
                cause = e_0;
                throw e_0;
              } else {
                throw $p;
              }
            }
            finally {
              cancelConsumed(tmp0, cause);
            }
          }
        } catch ($p) {
          if ($p instanceof ClosedSendChannelException()) {
            var _unused_var__etf5q3 = $p;
          } else {
            if ($p instanceof Error) {
              var cause_0 = $p;
              this.z5b_1.k1b();
              this.y5b_1.i5a_1.i1b(cause_0);
            } else {
              throw $p;
            }
          }
        }
        finally {
          this.z5b_1.k1b();
          var tmp0_safe_receiver = frameBody;
          if (tmp0_safe_receiver == null)
            null;
          else {
            tmp0_safe_receiver.l6();
          }
          this.y5b_1.i5a_1.k1b();
          if (!closeFramePresented) {
            yield* close(this.y5b_1, CloseReason().r59(Codes_CLOSED_ABNORMALLY_getInstance(), 'Connection was closed without close frame'), $completion);
          }
        }
        return Unit_instance;
      }
      ld(p1, $completion) {
        return this.w1f((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    DefaultWebSocketSessionImpl$runIncomingProcessor$slambdaClass = $;
  }
  return DefaultWebSocketSessionImpl$runIncomingProcessor$slambdaClass;
}
function DefaultWebSocketSessionImpl$runIncomingProcessor$slambda_0(this$0, $ponger) {
  var i = new (DefaultWebSocketSessionImpl$runIncomingProcessor$slambda())(this$0, $ponger);
  var l = ($this$launch, $completion) => i.w1f($this$launch, $completion);
  l.$arity = 1;
  return l;
}
var DefaultWebSocketSessionImpl$runOutgoingProcessor$slambdaClass;
function DefaultWebSocketSessionImpl$runOutgoingProcessor$slambda() {
  if (DefaultWebSocketSessionImpl$runOutgoingProcessor$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.c5c_1 = this$0;
      }
      *w1f($this$launch, $completion) {
        try {
          yield* /*#__NOINLINE__*/outgoingProcessorLoop(this.c5c_1, $completion);
        } catch ($p) {
          if ($p instanceof ClosedSendChannelException()) {
            var _unused_var__etf5q3 = $p;
          } else {
            if ($p instanceof ClosedReceiveChannelException()) {
              var _unused_var__etf5q3_0 = $p;
            } else {
              if ($p instanceof CancellationException()) {
                var _unused_var__etf5q3_1 = $p;
                yield* /*#__NOINLINE__*/sendCloseSequence(this.c5c_1, CloseReason().r59(Codes_NORMAL_getInstance(), ''), VOID, $completion);
              } else {
                if ($p instanceof ChannelIOException()) {
                  var _unused_var__etf5q3_2 = $p;
                } else {
                  if ($p instanceof Error) {
                    var cause = $p;
                    this.c5c_1.j5a_1.hx(CancellationException().p('Failed to send frame', cause));
                    yield* closeExceptionally(this.c5c_1.d5a_1, cause, $completion);
                    return Unit_instance;
                  } else {
                    throw $p;
                  }
                }
              }
            }
          }
        }
        finally {
          this.c5c_1.j5a_1.m1b();
          yield* close(this.c5c_1.d5a_1, VOID, $completion);
        }
        return Unit_instance;
      }
      ld(p1, $completion) {
        return this.w1f((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    DefaultWebSocketSessionImpl$runOutgoingProcessor$slambdaClass = $;
  }
  return DefaultWebSocketSessionImpl$runOutgoingProcessor$slambdaClass;
}
function DefaultWebSocketSessionImpl$runOutgoingProcessor$slambda_0(this$0) {
  var i = new (DefaultWebSocketSessionImpl$runOutgoingProcessor$slambda())(this$0);
  var l = ($this$launch, $completion) => i.w1f($this$launch, $completion);
  l.$arity = 1;
  return l;
}
var DefaultWebSocketSessionImpl$runOrCancelPinger$slambdaClass;
function DefaultWebSocketSessionImpl$runOrCancelPinger$slambda() {
  if (DefaultWebSocketSessionImpl$runOrCancelPinger$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.d5c_1 = this$0;
      }
      *e5c(it, $completion) {
        yield* /*#__NOINLINE__*/sendCloseSequence(this.d5c_1, it, IOException().l4h('Ping timeout'), $completion);
        return Unit_instance;
      }
      ld(p1, $completion) {
        return this.e5c(p1 instanceof CloseReason() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    DefaultWebSocketSessionImpl$runOrCancelPinger$slambdaClass = $;
  }
  return DefaultWebSocketSessionImpl$runOrCancelPinger$slambdaClass;
}
function DefaultWebSocketSessionImpl$runOrCancelPinger$slambda_0(this$0) {
  var i = new (DefaultWebSocketSessionImpl$runOrCancelPinger$slambda())(this$0);
  var l = (it, $completion) => i.e5c(it, $completion);
  l.$arity = 1;
  return l;
}
var DefaultWebSocketSessionImplClass;
function DefaultWebSocketSessionImpl() {
  if (DefaultWebSocketSessionImplClass === VOID) {
    class $ {
      constructor(raw, pingIntervalMillis, timeoutMillis, incomingFramesConfig, outgoingFramesConfig) {
        Companion_getInstance_1();
        this.d5a_1 = raw;
        this.e5a_1 = atomic$ref$1(null);
        this.f5a_1 = CompletableDeferred();
        this.g5a_1 = Job();
        this.h5a_1 = this.d5a_1.xv().fm(Key_instance).hm(this.g5a_1).hm(new (CoroutineName())('ws-default'));
        this.i5a_1 = from(Factory_getInstance(), incomingFramesConfig);
        this.j5a_1 = from(Factory_getInstance(), outgoingFramesConfig);
        this.k5a_1 = atomic$boolean$1(false);
        var tmp = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp.l5a_1 = ArrayList().p2();
        this.m5a_1 = atomic$boolean$1(false);
        this.n5a_1 = pingIntervalMillis;
        this.o5a_1 = timeoutMillis;
        this.p5a_1 = this.f5a_1;
      }
      xv() {
        return this.h5a_1;
      }
      x59() {
        return this.i5a_1;
      }
      y59() {
        return this.j5a_1;
      }
      k5b() {
        return this.l5a_1;
      }
      v59(value) {
        this.d5a_1.v59(value);
      }
      w59() {
        return this.d5a_1.w59();
      }
      t59() {
        return this.p5a_1;
      }
      u59(negotiatedExtensions) {
        if (!this.m5a_1.atomicfu$compareAndSet(false, true)) {
          // Inline function 'kotlin.error' call
          var message = 'WebSocket session ' + toString(this) + ' is already started.';
          throw IllegalStateException().o(toString(message));
        }
        // Inline function 'io.ktor.util.logging.trace' call
        var this_0 = get_LOGGER();
        if (get_isTraceEnabled(this_0)) {
          var tmp$ret$2 = 'Starting default WebSocketSession(' + toString(this) + ') ' + ('with negotiated extensions: ' + joinToString(negotiatedExtensions));
          this_0.k4s(tmp$ret$2);
        }
        this.l5a_1.u2(negotiatedExtensions);
        runOrCancelPinger(this);
        var incomingJob = runIncomingProcessor(this, ponger(this, this.y59()));
        var outgoingJob = runOutgoingProcessor(this);
        launch(this, VOID, VOID, DefaultWebSocketSessionImpl$start$slambda_0(incomingJob, outgoingJob, this));
      }
      *i4j($completion) {
        yield* this.d5a_1.i4j($completion);
        return Unit_instance;
      }
    }
    protoOf($).z59 = send;
    initMetadataForClass($, 'DefaultWebSocketSessionImpl', VOID, VOID, [DefaultWebSocketSession(), WebSocketSession()], [1, 0, 2]);
    DefaultWebSocketSessionImplClass = $;
  }
  return DefaultWebSocketSessionImplClass;
}
var properties_initialized_DefaultWebSocketSession_kt_6cjlhc;
function _init_properties_DefaultWebSocketSession_kt__469s0y() {
  if (!properties_initialized_DefaultWebSocketSession_kt_6cjlhc) {
    properties_initialized_DefaultWebSocketSession_kt_6cjlhc = true;
    LOGGER = KtorSimpleLogger('io.ktor.websocket.WebSocket');
    IncomingProcessorCoroutineName = new (CoroutineName())('ws-incoming-processor');
    OutgoingProcessorCoroutineName = new (CoroutineName())('ws-outgoing-processor');
    NORMAL_CLOSE = CloseReason().r59(Codes_NORMAL_getInstance(), 'OK');
    var tmp0_safe_receiver = get_OUTGOING_CHANNEL_CAPACITY();
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = new (ChannelConfig())(tmp0_safe_receiver, ChannelOverflow_SUSPEND_getInstance());
    }
    OUTGOING_CHANNEL_CONFIG = tmp;
  }
}
//region block: exports
export {
  DefaultWebSocketSession_0 as DefaultWebSocketSessionmehckluw85jl,
  DefaultWebSocketSession as DefaultWebSocketSession3h8506yqzs5fx,
  get_LOGGER as get_LOGGER1pnacb4n2g1eb,
};
//endregion

//# sourceMappingURL=DefaultWebSocketSession.mjs.map
